export const JWT_TOKEN_REFRESH = "jwt_token_refresh"
export const X_CSRF_TOKEN = "X-CSRFToken"
export const CSRFTOKEN = "csrftoken"
export const JWT_TOKEN = "jwt_token"